import { render, staticRenderFns } from "./DotsHorizontal.vue?vue&type=template&id=3174c38c&functional=true&"
import script from "./DotsHorizontal.vue?vue&type=script&lang=js&"
export * from "./DotsHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3174c38c')) {
      api.createRecord('3174c38c', component.options)
    } else {
      api.rerender('3174c38c', component.options)
    }
    module.hot.accept("./DotsHorizontal.vue?vue&type=template&id=3174c38c&functional=true&", function () {
      api.rerender('3174c38c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-material-design-icons/DotsHorizontal.vue"
export default component.exports